import axios from 'axios';
import queryString from 'query-string';

export default class Phone {

  init($) {
    const selector = $('.phone_track_link');
    this.api = axios.create({
      baseURL: process.env.NODE_ENV === 'test' ? 'http://hip.test/' : '/'
    });

    const siteIds = [];

    selector.each(function () {
      let phoneNumber = $(this).attr('data');
      phoneNumber = phoneNumber.replace(/\D/g, '');
      $('span', this).html(`${$.trim(phoneNumber.substring(0, phoneNumber.length - 2))}...`);
      $(this).css('display', 'inline-block');
      siteIds.push($(this).attr('data-sei'));
    });

    this.addUnMangleCodes(siteIds);

    selector.on('click', (e) => {
      e.preventDefault();
      const el = $(e.currentTarget);
      const text = el.attr('data-text');
      let realNumber;

      if (text) {
        realNumber = el.attr('data');
      } else {
        realNumber = this.reveal(el.attr('data'), el.attr('data-sei'));
      }

      const linkNumber = realNumber.replace(/[^+0-9]/g, '');

      el.replaceWith(`<a href="tel://${linkNumber}">${realNumber}</a>`);

      this.track(realNumber, el.attr('data-sei'), el.attr('data-eType'));
    });
  }

  addUnMangleCodes(siteIds) {
    if (window.un === undefined) {
      window.un = {};
    }

    if (siteIds.length) {
      this.api.get('/v2/phone/unmangle-code-data', {
        params: { siteIds }
      })
        .then((response) => {
          const codes = response.data.data;
          const siteIds = Object.keys(codes);
          if (siteIds.length > 0) {
            siteIds.forEach((siteId) => {
              window.un[siteId] = codes[siteId];
            });
          }
        });
    }
  }

  reveal(number, entityId) {
    const un = window.un;
    const pattern = /[^0-9]/gi;
    const cleanNumber = number.replace(pattern, '');

    if (un[entityId] instanceof Function) {
      return un[entityId](cleanNumber);
    }

    const data = un[entityId];
    const d = cleanNumber.substring.bind(cleanNumber);
    const e = cleanNumber.substr.bind(cleanNumber);
    const f = parseInt;
    let l = cleanNumber.length - data.numbersToMask;

    return d(0, l) + ((f(e(l++, 1)) + data.numbers[0]) % 10) + ((f(e(l++, 1)) + data.numbers[1]) % 10); // eslint-disable-line
  }

  track(phoneNumber, entityId, entityType) {
    return this.api.post('/v2/phone/click', queryString.stringify({
      entity_id: entityId,
      entity_type: entityType,
      origin_url: window.location.href,
      phone_number: phoneNumber
    }));
  }
}



// WEBPACK FOOTER //
// ./_common/scripts/phone.js